import { CustomPages } from '@enums/custom-pages';

export interface IToggleCustomPagesVisibility {
    data: {
        visible: number;
        type: CustomPages | string;
    };
}
